// extracted by mini-css-extract-plugin
export var component = "Grid-module--component--Glepr";
export var item = "Grid-module--item--AQ34S";
export var list = "Grid-module--list--veahx";